<template>
  <v-tooltip location="bottom">
    <template #activator="{ props }">
      <v-icon class="cursor-pointer" size="small" v-bind="props" :icon="mdiInformationOutline" />
    </template>
    <template #default>
      <slot />
    </template>
  </v-tooltip>
</template>

<script setup lang="ts">
import { mdiInformationOutline } from '@mdi/js'
</script>
